
function LoginSuccess() {
    return (
        <div className="container">
            <h1>Login Success Page</h1>
        </div>
    );
  }
  
  export default LoginSuccess;